import { formatDate_YMD, timeParseNoNull2 } from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";

/**
 * Fetches exposure data with valuation for unsettled exposure.
 * @param {object} _this - Context containing state variables.
 * @param {string} fieldName - Name of the field to update.
 * @param {boolean} fieldShowLoadingName - Flag to show loading indicator.
 * @param {Date|null} initialDate - Initial date (defaults to today).
 */
export function getAnalyticsCommodity(
  _this,
  fieldName,
  fieldShowLoadingName,
  initialDate = null,
) {
  initialDate = initialDate != null ? initialDate : new Date();
  _this[fieldShowLoadingName] = true;
  let params = {
    method: "POST",
    endpoint: "analytics_commodity",
    content_type: "application/json",
    query_params: {
      companies: {
        id_companies: _this.selectedCompanies.map((d) => d.pk_idcompany),
      },
      date: formatDate_YMD(initialDate),
      end_product: {
        id_assets: _this.selectedAsset.map((d) => d.pk_id_end_product),
      },
      format: "json",
      portfolios: { id_portfolios: _this.portfolioNumbers },
    },
  };
  let dateFieldsExpo = [
    "created_at",
    "date",
    "date_required",
    "eta",
    "fixation_date",
    "loading_date",
    "p_date",
    "purchase_date",
    "sale_date",
    "shipping_date",
    "updated_at",
  ];
  let dateFieldsHedge = [
    "asian_fixing_start_date",
    "created_at",
    "fixing_date",
    "hedged_date",
    "premium_value_date",
    "selected_contract",
    "trade_date",
    "updated_at",
    "value_date",
  ];
  apiService
    .getAll(params)
    .then((data) => {
      data = JSON.parse(JSON.stringify(data));
      // parse expo
      data[0].expo.forEach(function(d) {
        for (let i = 0; i < dateFieldsExpo.length; i++) {
          d[dateFieldsExpo[i]] = timeParseNoNull2(d[dateFieldsExpo[i]]);
        }
      });
      // parse hedge
      data[0].hedge.forEach(function(d) {
        for (let i = 0; i < dateFieldsHedge.length; i++) {
          d[dateFieldsHedge[i]] = timeParseNoNull2(d[dateFieldsHedge[i]]);
        }
        d.date = d.fixing_date;
        d.notional = +d.quantity;
        d.quantity_hedge = +d.quantity;
        d.settlement_rate_hedge =
          d.settlement_rate == null ? null : d.settlement_rate;
        d.continuation_month_hedge = d.continuation_month;
        d.contract_month_year_hedge = d.contract_month_year;
        d.cash_flow = 0;
        d.balance = 0;
      });
      _this[fieldName] = data;
      _this[fieldShowLoadingName] = false;
    })
    .catch(function(error) {
      _this[fieldName] = [];
      _this[fieldShowLoadingName] = false;
      console.error(error);
    });
}
